import { monoPalette } from "@/styles/themes/colors/palettes";

export const aliasDark = {
  main: monoPalette.dark[87],
};
export type AliasDarkScheme = "dark";
export type AliasDark = `${AliasDarkScheme}.${keyof typeof aliasDark}`;
